import { render, staticRenderFns } from "./DiscussionCards.vue?vue&type=template&id=3bb55de1&"
import script from "./DiscussionCards.vue?vue&type=script&lang=js&"
export * from "./DiscussionCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports